export default function GrowLabLogo({ size = 120 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width={size} height={size}>
      <defs>
        <style>{`
          @keyframes pulse-a  { 0%,100%{opacity:1} 50%{opacity:0.25} }
          @keyframes pulse-b  { 0%,100%{opacity:1} 50%{opacity:0.2}  }
          @keyframes dash-flow{ from{stroke-dashoffset:120} to{stroke-dashoffset:0} }
          @keyframes glow-fade{ 0%,100%{opacity:0.1} 50%{opacity:0.28} }
          .gl-shaft{ stroke-dasharray:120; animation:dash-flow 2.4s linear infinite; }
          .gl-na{ animation:pulse-a 1.8s ease-in-out infinite; }
          .gl-nb{ animation:pulse-b 1.8s ease-in-out infinite; animation-delay:0.2s }
          .gl-nc{ animation:pulse-b 1.8s ease-in-out infinite; animation-delay:0.5s }
          .gl-nd{ animation:pulse-a 1.8s ease-in-out infinite; animation-delay:0.8s }
          .gl-ne{ animation:pulse-b 1.8s ease-in-out infinite; animation-delay:1.1s }
          .gl-glw{ animation:glow-fade 2s ease-in-out infinite; }
        `}</style>
        <filter id="gl-fg">
          <feGaussianBlur stdDeviation="3" result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <filter id="gl-fc">
          <feGaussianBlur stdDeviation="2.5" result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <linearGradient id="gl-sg" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%"   stopColor="#1DB954"/>
          <stop offset="100%" stopColor="#1DB954" stopOpacity="0.55"/>
        </linearGradient>
      </defs>

      {/* Outer glow ring */}
      <circle cx="100" cy="100" r="88" fill="#1DB954" opacity="0.04" className="gl-glw"/>
      <circle cx="100" cy="100" r="88" fill="none" stroke="#1DB954" strokeWidth="0.5" opacity="0.1"/>

      {/* Circuit cross-ticks */}
      <line x1="68"  y1="118" x2="68"  y2="130" stroke="#1DB954" strokeWidth="1" opacity="0.2"/>
      <line x1="62"  y1="124" x2="74"  y2="124" stroke="#1DB954" strokeWidth="1" opacity="0.2"/>
      <line x1="100" y1="86"  x2="100" y2="98"  stroke="#00FFFF" strokeWidth="1" opacity="0.2"/>
      <line x1="94"  y1="92"  x2="106" y2="92"  stroke="#00FFFF" strokeWidth="1" opacity="0.2"/>
      <line x1="132" y1="58"  x2="132" y2="70"  stroke="#00FFFF" strokeWidth="1" opacity="0.2"/>
      <line x1="126" y1="64"  x2="138" y2="64"  stroke="#00FFFF" strokeWidth="1" opacity="0.2"/>

      {/* Main shaft */}
      <line x1="44" y1="160" x2="160" y2="44"
            stroke="url(#gl-sg)" strokeWidth="2.5" strokeLinecap="round"
            className="gl-shaft" filter="url(#gl-fg)"/>

      {/* Arrowhead */}
      <polyline points="136,44 160,44 160,68"
                fill="none" stroke="#1DB954" strokeWidth="2.8"
                strokeLinecap="round" strokeLinejoin="round"
                filter="url(#gl-fg)"/>

      {/* Node A — origin */}
      <circle cx="44"  cy="160" r="5.5" fill="#1A1A1A" stroke="#1DB954" strokeWidth="2"   className="gl-na" filter="url(#gl-fg)"/>
      <circle cx="44"  cy="160" r="2"   fill="#1DB954" className="gl-na"/>

      {/* Node B */}
      <circle cx="68"  cy="136" r="4.5" fill="#1A1A1A" stroke="#1DB954" strokeWidth="1.8" className="gl-nb"/>
      <circle cx="68"  cy="136" r="1.8" fill="#1DB954" className="gl-nb"/>

      {/* Node C */}
      <circle cx="100" cy="104" r="4.5" fill="#1A1A1A" stroke="#00FFFF" strokeWidth="1.8" className="gl-nc" filter="url(#gl-fc)"/>
      <circle cx="100" cy="104" r="1.8" fill="#00FFFF" className="gl-nc"/>

      {/* Node D */}
      <circle cx="132" cy="72"  r="4.5" fill="#1A1A1A" stroke="#00FFFF" strokeWidth="1.8" className="gl-nd" filter="url(#gl-fc)"/>
      <circle cx="132" cy="72"  r="1.8" fill="#00FFFF" className="gl-nd"/>

      {/* Node E — tip */}
      <circle cx="160" cy="44"  r="5.5" fill="#1A1A1A" stroke="#1DB954" strokeWidth="2.2" className="gl-ne" filter="url(#gl-fg)"/>
      <circle cx="160" cy="44"  r="2.2" fill="#1DB954" className="gl-ne"/>
    </svg>
  )
}
